(function () {
    'use strict';

    angular.module("EventListApp").filter('niceTextBreak', function () {
        return function (text, length) {
            if (isNaN(length))
                length = 10;

            if (!text)
                return;

            // escape first: output is bound with ng-bind-html, so only the <br> we add may be markup
            var safe = String(text)
                .replaceAll('&', '&amp;')
                .replaceAll('<', '&lt;')
                .replaceAll('>', '&gt;');

            if (safe.length <= length)
                return safe;

            return safe.replaceAll(',', ',<br>');
        };
    });

})();